import React from 'react';
import { Label } from 'semantic-ui-react';
import circleInfo from '../../semantic-ui/site/assets/circle-info.svg';

const InformationIcon = ({ tooltip, tooltipStyle, pointing = "below" }) => {
    return (
        <span className="info-icon">
            <img src={circleInfo} />
            <Label basic pointing={pointing} style={tooltipStyle}>
                {tooltip}
            </Label>
        </span>
    );
};

export default InformationIcon;
